import { render } from "./EventInstancesPreview.vue?vue&type=template&id=12922ed4&ts=true"
import script from "./EventInstancesPreview.vue?vue&type=script&lang=ts"
export * from "./EventInstancesPreview.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__